import { app_hostname_hdr_RowClass } from "../../dbschema";
import { BaseContainerModel } from "../base-container.model";


export class HostnameModel extends BaseContainerModel {
    app_hostname_hdr: app_hostname_hdr_RowClass = new app_hostname_hdr_RowClass();
}